<template>
    <!-- <div style="display: flex; flex-direction: column;"> -->
    <div class='categroy'>
        <div class="categroy_header">
            <nav>
                <ul class="cl-ul cl-display--flex cl-flex--row cl-flex--wrap cl-align--center">
                    <li>
                        <a href="/" class="home" itemprop="item">
                            <svg class="svg-inline--fa fa-home fa-w-18" aria-hidden="true" focusable="false"
                                data-prefix="fas" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 576 512" data-fa-i2svg="">
                                <path fill="currentColor"
                                    d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z">
                                </path>
                            </svg><!-- <i class="fas fa-home"></i> Font Awesome fontawesome.com -->
                            <span style="display: none;" itemprop="name">首頁</span>
                        </a>
                    </li>
                    <li>{{ this.$route.params.name }}</li>
                </ul>
            </nav>
        </div>
        <div class="categroy_content">
            <div class="categroy_left">
                <ul class="cl-ul">
                    <li v-for="item_cate in cate" @click="gocate(item_cate)"><a class='cl-a' href="javascript:;">{{
                        item_cate.cate_name }}</a></li>
                    <!-- <li><a class='cl-a' href="javascript:;">充電類</a></li>
                    <li><a class='cl-a' href="javascript:;">充電類</a></li>
                    <li><a class='cl-a' href="javascript:;">充電類</a></li>
                    <li><a class='cl-a' href="javascript:;">充電類</a></li> -->
                </ul>
            </div>
            <div class="categroy_right">
                <div class="collection_title">
                    <h1>{{ this.$route.params.name }}</h1>
                    <div class="setting">
                        <p>共 {{ category_list.length }} 件商品</p>
                        <div class="select">
                            <!-- <select class="product-sort-by" name="" id="" v-model="sortBy" @change="onSort($event)">
                                <option value="">預設排序</option>
                                <option value="price-desc">價格由高到低</option>
                                <option value="price-asc">價格由低到高</option>
                                <option value="sell_from-asc">上市日期舊到新</option>
                                <option value="sell_from-desc">上市日期新到舊</option>
                                <option value="recent_days_sold-desc">本週熱賣</option>
                            </select> -->
                        </div>
                        <div class="btn_group">
                            <button style="margin-right: 10px;" @click="style_status = 1"
                                :style="style_status == 1 ? { color: '#565656' } : { color: '#a3a3a3' }">
                                <svg class="svg-inline--fa fa-th-large fa-w-16" aria-hidden="true" focusable="false"
                                    data-prefix="fas" data-icon="th-large" role="img" xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512" data-fa-i2svg="">
                                    <path fill="currentColor"
                                        d="M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z">
                                    </path>
                                </svg>
                            </button>
                            <button @click="style_status = 2"
                                :style="style_status == 2 ? { color: '#565656' } : { color: '#a3a3a3' }">
                                <svg class="svg-inline--fa fa-list fa-w-16" aria-hidden="true" focusable="false"
                                    data-prefix="fas" data-icon="list" role="img" xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512" data-fa-i2svg="">
                                    <path fill="currentColor"
                                        d="M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z">
                                    </path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="products_content">
                    <section class="cl-display--grid grid-item "
                        :class="style_status == 1 ? 'square_prods' : 'line_prods'">
                        <div v-for="item in category_list" class="grid-item--list">
                            <div>
                                <a href="javascript:;" class="back_img cl-a">
                                    <img @click="godetails(item)" v-lazy="item.images" :alt="item.group_name">
                                    <div class="back_hover">
                                        <div class="details" title="查看详情" @click="godetails(item)">
                                            <svg class="svg-inline--fa fa-search fa-w-16 qk-text--button"
                                                aria-hidden="true" focusable="false" data-prefix="fas"
                                                data-icon="search" role="img" xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512" data-fa-i2svg="">
                                                <path fill="currentColor"
                                                    d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z">
                                                </path>
                                            </svg>
                                            <span>查看商品</span>
                                        </div>
                                        <div class="add" @click="addToCart(item)">
                                            <svg class="svg-inline--fa fa-shopping-cart fa-w-18" aria-hidden="true"
                                                focusable="false" data-prefix="fas" data-icon="shopping-cart" role="img"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"
                                                data-fa-i2svg="">
                                                <path fill="currentColor"
                                                    d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z">
                                                </path>
                                            </svg>
                                            <span>加入購物車</span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <!-- <img src="https://imagedelivery.net/i8Xoxd20xJp7bcbNAjF34A/54439342-ae54-4fe4-7015-0f087a376d00/shopitemmobile"
                        alt=""> -->
                            <div class="cl-display--flex cl-align--center cl-flex--column content">
                                <div class="content-price">
                                    <h5 @click="godetails(item)" class="cl-text--center cl-mg--0 cl-cur--pointer">
                                        {{ item.group_name }}</h5>
                                    <div class="content-details" style="white-space: pre-line;">
                                        {{ item.content }}
                                    </div>
                                    <div v-if="item.price_original_max - item.price_max != 0" class="price">
                                        <span class="preferential">${{
                        item.price_min | formatNumberToqff }}</span>
                                        <span class="original-price"><del>${{ item.price_original_max |
                        formatNumberToqff
                                                }}</del></span>
                                    </div>
                                    <div v-else class="price">
                                        <!-- <span class="original-price"><del>原價：${{ item.price_original_max | formatNumberToqff }}</del></span> -->
                                        <span class="preferential">${{
                        item.price_original_max | formatNumberToqff }}</span>
                                    </div>
                                </div>
                                <div class="icon cl-text--center" @click="addToCart(item)">
                                    加入購物車
                                </div>

                            </div>
                            <div class="line_prods_icon cl-text--center" @click="addToCart(item)">
                                加入購物車
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="centerDialogVisible" class="dialog" @open="resetScroll()" @close="dialog_close()">
            <div class="close" @click="centerDialogVisible = false;"><i class="el-icon-close"></i></div>
            <div id="centerDialogVisible">
                <div class="shop_content" v-loading="loading" id="shop_content"
                    element-loading-background="rgba(255,255,255,1)">
                    <div class="shop">
                        <div class="shop_left">
                            <div class="swiper">
                                <swiper :thumbs="{ swiper: thumbsSwiper }" @slideChange="updateActiveSlideIndex"
                                    :slides-per-view="1" :observer='true' :observeParents='true' :navigation="true"
                                    :autoHeight="true" :options="swiperOptions">
                                    <swiper-slide class="test" v-for="items in item.items">
                                        <img v-lazy="items.display_img_small" alt="">
                                    </swiper-slide>
                                </swiper>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                        <div class="shop_right">
                            <!-- <span>{{ item.name }}</span> -->
                            <h4>{{ item.group_name }}</h4>
                            <p style="white-space: pre-line;">
                                {{ item.content }}
                            </p>
                            <div class="swiper_thumbs">

                                <swiper @swiper="setThumbsSwiper" :allowTouchMove="false" :slides-per-view="3"
                                    :loop="false" :pagination="true">
                                    <swiper-slide class="test" v-for="items, index in item.items" :key="index"
                                        watch-slides-visibility watch-slides-progress
                                        :class="{ 'active-slide': index === activeSlideIndex }">
                                        <img v-lazy="items.display_img_small" alt="img" />
                                    </swiper-slide>
                                </swiper>
                            </div>
                            <div class="price" v-if="list_index == null">
                                <span>${{ item.price_min | formatNumberToqff }}</span>
                                <del>${{ item.price_original_max | formatNumberToqff }}</del>
                            </div>
                            <div v-else class="price">
                                <span>${{ list_num_price | formatNumberToqff }}</span>
                                <!-- <del>${{ item.price_original_max | formatNumberToqff}}</del> -->
                            </div>
                            <div class="specification">
                                <div style="margin-bottom: 5px;">規格</div>
                                <!-- <div class="option selected">复古绿</div>
                                <div class="option">复古红</div>
                                <div class="option">复古黄</div>
                                <div class="option">复古黄</div> -->
                                <div @click="selectlist(index)" :class="{ selected: list_index === index }"
                                    class="option" v-for="(list, index) in item.items">{{ list.name }}
                                </div>
                            </div>
                            <div class="mb_pc">
                                <div class="number">
                                    <button type="button" class="btn iconfont" @click="reduce()">-
                                    </button>
                                    <input @change="handleChange(list_num)" type="number" name="quantity"
                                        v-model="list_num" class="border-0 text-center w-100   p-0" data-max="1"
                                        data-min="1">
                                    <button type="button" class="btn iconfont" @click="add()">+
                                    </button>
                                </div>
                                <!-- <div class="addcart" @click="addcart()">
                                    加入購物車
                                </div> -->
                                <div class="btncart">
                                    <div class="addcart" @click="addcart()">
                                        加入購物車
                                    </div>
                                    <div class="gocart" @click="addcart('go')">
                                        立即購買
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shop_details">
                        <h5 id="desc">| 商品介绍</h5>
                        <div v-for="item in item?.info?.desc">
                            <img v-if="item.content_type == 'IMAGE'" :src="item.content" alt="">
                            <div class="video-wrapper" v-else-if="item.content_type == 'YOUTUBE'">
                                <iframe
                                    :src="'https://www.youtube.com/embed/' + item.content.split('v=')[1].split('&')[0]"
                                    frameborder="0" allowfullscreen></iframe>
                            </div>
                            <div v-else>
                                {{ item.content }}
                            </div>
                        </div>
                        <h5 id="notice">| 規格說明</h5>
                        <div v-for="item in item?.info?.notice">
                            <img v-if="item.content_type == 'IMAGE'" :src="item.content" alt="">
                            <div class="video-wrapper" v-else-if="item.content_type == 'YOUTUBE'">
                                <iframe
                                    :src="'https://www.youtube.com/embed/' + item.content.split('v=')[1].split('&')[0]"
                                    frameborder="0" allowfullscreen></iframe>
                            </div>
                            <div v-else>
                                {{ item.content }}
                            </div>
                        </div>
                        <h5 id="delivery">| 注意事項</h5>
                        <div v-for="item in item?.info?.delivery">
                            <img v-if="item.content_type == 'IMAGE'" :src="item.content" alt="">
                            <div class="video-wrapper" v-else-if="item.content_type == 'YOUTUBE'">
                                <iframe
                                    :src="'https://www.youtube.com/embed/' + item.content.split('v=')[1].split('&')[0]"
                                    frameborder="0" allowfullscreen></iframe>
                            </div>
                            <div v-else>
                                {{ item.content }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>


        <el-dialog :visible.sync="ChildDialogVisible" class="child_dialog">
            <!-- <Child_list @dialog_close="dialog_close" :list_itemid="this.list_itemid" :child_list="this.child_list"
                :child_num="this.child_num" :list_num="this.list_num"></Child_list> -->
            <h2>請選擇 {{ this.child_num }} 份商品</h2>
            <div v-for="item, index in child_list">
                <div class="form_name">{{ item.form_name }}</div>
                <div class="number">
                    <button type="button" class="btn iconfont" @click="decrement(index)">-
                    </button>
                    <input type="number" name="quantity" @input="validateInput(index)" v-model="item.display_num"
                        class="border-0 text-center w-100   p-0" data-max="1" data-min="1">
                    <button type="button" class="btn iconfont" @click="increment(index)">+
                    </button>
                </div>
            </div>
            <div class="btn">
                <button @click="checkChild_list">確認</button>
            </div>
        </el-dialog>
        <Navbar></Navbar>
    </div>
    <!-- <Footer></Footer> -->
    <!-- </div> -->
</template>

<script>
import Vue from 'vue';
import numeral from "numeral";
import { Carousel, CarouselItem, Dialog, Loading, InputNumber } from 'element-ui';
Vue.use(Carousel);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(CarouselItem);
Vue.use(InputNumber);
import { mapState } from 'vuex';
import { Navigation, Pagination, Thumbs } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import 'swiper/swiper-bundle.css'
SwiperCore.use([Navigation, Pagination, Thumbs])
import FacebookEventApi from '@/js/FacebookEventApi'
import Navbar from '@/components/navbar/index.vue'
import Footer from '@/components/footer/index.vue'
export default {
    components: {
        Navbar,
        Footer,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            sortBy: '',
            style_status: 1,
            products: [], // 商品列表
            productDetails: null, // 当前选中的商品详情
            centerDialogVisible: false, // 弹窗是否可见
            loading: true, // 是否正在加载商品详情
            list: [

            ],
            item: {},
            swiperOptions: {

            },
            //子商品
            child_list: [],//子商品内容
            child_num: '',//子商品默认数量
            child_number: '',//记录商品数量总和
            parm: [],//修改后的子商品各个的数量

            //赠品
            free: [],//赠品
            free_num: '',//赠品数量
            free_number: '',//记录赠品数量总和
            free_parm: [],//修改后的赠品各个的数量


            issub: false,
            ChildDialogVisible: false,//子商品弹窗
            thumbsSwiper: null,
            activeSlideIndex: 0,
            list_index: null,//选择規格
            list_num: 1,//选择規格后的数量
            list_price: null,//选择規格后的价格
            list_itemid: null,//选择規格后的itemid
            list_price: null,//选择規格后的价格
            list_num_price: null,//选择規格后的数量*价格

            // addtocart2
            content_name: '',//商品名字
            content_ids: '',//id
            values: '',//价格
            contents_quantity: ''//数量

        };
    },
    computed: {
        ...mapState('header', ['cate', 'getfb']),
        ...mapState('commodity', ['category_list', 'details']),
        ...mapState('cart', ['number', 'cart_list_item']),

        totalSum() {
            return this.child_list.reduce((sum, item) => sum + item.display_num, 0);
        }
    },
    filters: {
        formatNumberToqff(val) {
            return numeral(val).format('0,0');
        }
    },
    watch: {},
    methods: {
        onSort(e) {
            console.log(e);
            console.log(this.sortBy);
        },
        addToCart(item) {
            this.centerDialogVisible = true;
            this.$store.dispatch('commodity/getdesignated_product', item.oig_id).then(response => {
                this.item = this.$store.getters["commodity/details"];
                if (this.item.items.length == 1) {
                    this.selectlist(0);
                }
                this.loading = false;
            })

        },
        //关闭弹窗事件
        dialog_close() {
            this.loading = true;
            this.list_index = null;
            this.list_num = 1;
            this.thumbsSwiper = null;
            this.activeSlideIndex = 0;
        },
        //选择規格
        selectlist(e) {
            // console.log(e);
            this.list_price = this.item.items[e].price;
            this.list_num_price = this.list_price * this.list_num;
            this.list_itemid = this.item.items[e].itemid;
            // console.log();
            this.list_index = e;
            this.getProducts(this.item.items[e].itemid);
            this.parm = [];


            this.content_name = this.item.items[e].form_name;
            this.content_ids = this.item.items[e].itemid;
            this.values = this.item.items[e].price;
            this.contents_quantity = 1;
        },
        // 轮播缩略图
        setThumbsSwiper(swiper) {
            this.thumbsSwiper = swiper;
        },
        //缩略图添加样式
        updateActiveSlideIndex(swiper) {
            // console.log(1);
            this.activeSlideIndex = swiper.activeIndex;
            // this.$forceUpdate();
        },
        // 弹出框打开置顶
        resetScroll() {
            this.$nextTick(() => {
                const element = document.getElementById('shop_content');
                if (element) {
                    element.scrollTop = 0;
                }
            });
        },
        //数量减少
        reduce() {
            if (this.list_num > 1) {
                this.list_num--;
            } else {
                this.list_num = 1;
            }
            this.list_num_price = this.list_price * this.list_num;
        },
        //数量增加
        add() {
            if (this.list_index == null) {
                this.$notify({
                    title: '未选择規格',
                    type: 'warning'
                });
            } else {
                this.list_num++;
            }
            this.list_num_price = this.list_price * this.list_num;
        },
        //修改商品数量
        handleChange(val) {
            if (this.list_index == null) {
                this.$notify({
                    title: '未选择規格',
                    type: 'warning'
                });
                this.list_num = 1;
            } else {
                this.list_num = val;
            }
            this.list_num_price = this.list_price * this.list_num;
        },
        //加入购物车
        addcart(e) {
            if (this.list_index == null) {
                this.$notify({
                    title: '未選擇規格',
                    type: 'warning'
                });
            } else {

                var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash);
                var fb_em = myFacebookEventApi.fbgetCookie('em');
                var fb_phone = myFacebookEventApi.fbgetCookie('phone');
                var fb_fn = myFacebookEventApi.fbgetCookie('fn');
                var fb_external_id = myFacebookEventApi.fbgetCookie('external_id');
                var fb_fbclid = myFacebookEventApi.fbgetCookie('fbclid');
                myFacebookEventApi.callAddToCart2('item' + this.content_ids, this.content_name, this.contents_quantity, this.values,fb_em, fb_phone, fb_fn, fb_external_id, fb_fbclid);
                if (this.issub) {
                    if (this.parm.length === 0) {
                        this.$notify({
                            title: '請先選擇子商品',
                            type: 'warning'
                        });
                        this.ChildDialogVisible = true;
                    } else {
                        this.$swal.fire({
                            allowOutsideClick: false, // 禁止点击外部关闭弹窗
                            customClass: {
                                popup: 'custom-swal'
                            },
                            didOpen: () => {
                                this.$swal.showLoading(); // 显示加载动画
                            }
                        });
                        this.centerDialogVisible = false;
                        this.parm = this.child_list.map(item => {
                            return {
                                item: item.isubid,
                                num: item.display_num
                            };
                        });
                        this.parm.forEach(element => {
                            element.num = element.num * this.list_num;
                        });
                        this.free_parm = this.free.map(item => {
                            // number_free += item.display_num
                            return {
                                item: item.isubid,
                                num: this.free_num * this.list_num
                            };
                        });
                        this.child_number = this.list_num
                        if (this.cart_list_item.length != 0) {
                            this.cart_list_item.forEach(element => {
                                if (this.list_itemid == element.item_id) {
                                    this.child_number += element.num
                                    element.sub.forEach(sub_item => {
                                        const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
                                        if (existingItem) {
                                            // 如果存在，则将数量相加
                                            existingItem.num += sub_item.num;
                                        }
                                        const free_existingItem = this.free_parm.find(item1 => item1.item === sub_item.isubid);
                                        if (free_existingItem) {
                                            // 如果存在，则将数量相加
                                            free_existingItem.num += sub_item.num;
                                        }
                                    });
                                }
                            });
                        }
                        this.parm = this.parm.concat(this.free_parm);
                        this.$store.dispatch('cart/child_update', {
                            itemid: this.list_itemid,
                            number: this.child_number,
                            param: this.parm
                        }).then(response => {
                            this.$swal.fire({
                                html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
          <circle class="circle" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="36.7" cy="36.7" r="35.2"></circle>
          <polyline class="success_path" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="23.7,36.8 32.4,45.4 49.7,28 "></polyline>
        </svg><div>已加入購物車</div>`,
                                showConfirmButton: false,
                                customClass: {
                                    popup: 'icon-popup'
                                },
                            });
                            // 设置延时器在一秒后关闭弹窗
                            setTimeout(() => {
                                this.$swal.close();
                            }, 1000); // 1000 毫秒等于 1 秒
                            if (e == 'go') {
                                this.$router.push({
                                    path: `/cart`,
                                });
                            }
                        });
                    }

                } else {
                    this.$swal.fire({
                        allowOutsideClick: false, // 禁止点击外部关闭弹窗
                        customClass: {
                            popup: 'custom-swal'
                        },
                        didOpen: () => {
                            this.$swal.showLoading(); // 显示加载动画
                        }
                    });
                    this.centerDialogVisible = false;
                    this.parm = this.child_list.map(item => {
                            return {
                                item: item.isubid,
                                num: item.display_num
                            };
                        });
                        this.parm.forEach(element => {
                            element.num = element.num * this.list_num;
                        });
                        this.free_parm = this.free.map(item => {
                            // number_free += item.display_num
                            return {
                                item: item.isubid,
                                num: this.free_num * this.list_num
                            };
                        });
                        this.child_number = this.list_num
                        if (this.cart_list_item.length != 0) {
                            this.cart_list_item.forEach(element => {
                                if (this.list_itemid == element.item_id) {
                                    this.child_number += element.num
                                    element.sub.forEach(sub_item => {
                                        const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
                                        if (existingItem) {
                                            // 如果存在，则将数量相加
                                            existingItem.num += sub_item.num;
                                        }

                                        const free_existingItem = this.free_parm.find(item1 => item1.item === sub_item.isubid);
                                        if (free_existingItem) {
                                            // 如果存在，则将数量相加
                                            free_existingItem.num += sub_item.num;
                                        }
                                    });

                                }
                            });
                        }
                        this.parm = this.parm.concat(this.free_parm);
                        this.$store.dispatch('cart/child_update', {
                            itemid: this.list_itemid,
                            number: this.child_number,
                            param: this.parm
                        }).then(response => {
                        if (response.result) {
                            this.$swal.fire({
                                html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
          <circle class="circle" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="36.7" cy="36.7" r="35.2"></circle>
          <polyline class="success_path" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="23.7,36.8 32.4,45.4 49.7,28 "></polyline>
        </svg><div>已加入購物車</div>`,
                                showConfirmButton: false,
                                customClass: {
                                    popup: 'icon-popup'
                                },
                            });
                        } else {
                            this.$swal.fire({
                                html: `<svg xmlns="http://www.w3.org/2000/svg" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
        <line fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" x1="20" y1="20" x2="53.4" y2="53.4" />
        <line fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" x1="53.4" y1="20" x2="20" y2="53.4" />
    </svg>
    <div>${response.message}</div>`,
                                showConfirmButton: false,
                                customClass: {
                                    popup: 'icon-popup'
                                },
                            });
                        }
                        // 设置延时器在一秒后关闭弹窗
                        setTimeout(() => {
                            this.$swal.close();
                        }, 1000); // 1000 毫秒等于 1 秒
                        if (e == 'go') {
                            this.$router.push({
                                path: `/cart`,
                            });
                        }
                    });
                }
            }
        },
        //前往详情页
        godetails(e) {
            // console.log(e.oig_id);
            this.$router.push({
                path: `/details/${e.oig_id}`,
            }).catch(err => { })
        },
        // 前往商品组
        gocate(item) {
            this.$router.push({
                path: `/categroy/${item.cate_name}/${item.cid}`,
            });
            this.$store.dispatch('commodity/getclassification', item.cid).then(e => {
            })
        },
        //子商品
        getProducts(id) {
            this.$store.dispatch('commodity/getsubcategory', id).then(response => {
                // this.products = this.$store.getters["commodity/products"];
                // console.log(response);
                if (response.result) {
                    this.child_list = response.data.sub || [];
                    this.child_num = response.data.num || 0;
                    this.free = response.data.sub_free || [];
                    this.free_num = response.data.num_free || 0;
                    if (response.data.sub.length === 1) {
                        this.child_list[0].display_num = response.data.num
                        switch (response.data.sub_free.length) {
                            case 0:
                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                break;
                            default:
                                // this.list_num
                                this.free_parm = this.free.map(item => {
                                    // number_free += item.display_num
                                    return {
                                        item: item.isubid,
                                        num: this.free_num * this.list_num
                                    };
                                });
                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                break;
                        }
                        this.issub = true
                    } else
                        if (response.data.num != 0) {
                            this.ChildDialogVisible = true;

                            this.issub = true
                        } else if (response.data.sub.length === 0) {

                            switch (response.data.sub_free.length) {
                                case 0:
                                    this.parm = [
                                    ]
                                    break;
                                default:
                                    this.free_parm = this.free.map(item => {
                                        // number_free += item.display_num
                                        return {
                                            item: item.isubid,
                                            num: this.free_num * this.number
                                        };
                                    });
                                    this.parm = [
                                    ]
                                    break;
                            }
                            this.issub = false
                        }
                } else {
                    this.$notify({
                        title: `${response.message}`,
                        type: 'warning'
                    });
                    this.issub = false
                }
            });
        },
        increment(index) {
            if (this.totalSum < this.child_num) {
                this.child_list[index].display_num++;
            }
        },
        validateInput(index) {
            // 确保当前输入是一个有效数字
            this.child_list[index].display_num = Math.max(0, parseInt(this.child_list[index].display_num) || 0);

            // 计算所有 display_num 的总和
            let total = this.child_list.reduce((sum, item) => sum + item.display_num, 0);

            // 如果总和超过 child_num，则减少当前输入的值
            if (total > this.child_num) {
                let excess = total - this.child_num;
                this.child_list[index].display_num = Math.max(0, this.child_list[index].display_num - excess);
            }
        },
        decrement(index) {
            if (this.child_list[index].display_num > 0) {
                this.child_list[index].display_num--;
            }
        },
        checkChild_list() {
            let number = 0
            this.parm = this.child_list.map(item => {
                number += item.display_num
                return {
                    item: item.isubid,
                    num: item.display_num
                };
            });
            // if (this.cart_list_item.length != 0) {
            //     this.cart_list_item.forEach(element => {
            //         if (this.list_itemid == element.item_id) {
            //             this.list_num += element.num
            //             element.sub.forEach(sub_item => {
            //                 const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
            //                 if (existingItem) {
            //                     // 如果存在，则将数量相加
            //                     existingItem.num += sub_item.num;
            //                 }
            //             });
            //         }
            //     });
            // }
            if (number == this.child_num) {
                // console.log(this.parm, this.list_num);
                this.ChildDialogVisible = false
                // this.$emit('dialog_close', { parm: this.parm, number: this.num });
            } else {
                this.$notify({
                    title: `數量選擇有錯哦! 您可以選 ${this.child_num} 樣商品^_^`,
                    type: 'warning'
                });
            }
        },

    },
    created() {
    },
    mounted() {
        this.$store.dispatch('commodity/getclassification', this.$route.params.id).then(e => {
            // this.list = e.data;
        })
    },
}
</script>

<style src="./index.scss" lang='scss' scoped></style>